import React__default from 'react';
import { RadioGroupCore } from '../shared/components/RadioGroup.mjs';
import { Radio } from './Radio.mjs';

const formGroupSx = {
    flexDirection: 'row'
};
const RadioGroup = (props)=>{
    return /*#__PURE__*/ React__default.createElement(RadioGroupCore, {
        ...props,
        formGroupSx: formGroupSx,
        RadioComponent: Radio
    });
};

export { RadioGroup };
//# sourceMappingURL=RadioGroup.mjs.map
